const openAlexSdgs = [
    {
        id: "unknown",
        display_name: "unknown",
        count: 150366988
    },
    {
        id: "https://metadata.un.org/sdg/3",
        display_name: "Good health and well-being",
        count: 18125679
    },
    {
        id: "https://metadata.un.org/sdg/10",
        display_name: "Reduced inequalities",
        count: 17034272
    },
    {
        id: "https://metadata.un.org/sdg/8",
        display_name: "Decent work and economic growth",
        count: 15556342
    },
    {
        id: "https://metadata.un.org/sdg/17",
        display_name: "Partnerships for the goals",
        count: 14988141
    },
    {
        id: "https://metadata.un.org/sdg/9",
        display_name: "Industry, innovation and infrastructure",
        count: 14820907
    },
    {
        id: "https://metadata.un.org/sdg/16",
        display_name: "Peace, Justice and strong institutions",
        count: 13941286
    },
    {
        id: "https://metadata.un.org/sdg/12",
        display_name: "Responsible consumption and production",
        count: 12452856
    },
    {
        id: "https://metadata.un.org/sdg/4",
        display_name: "Quality Education",
        count: 12097247
    },
    {
        id: "https://metadata.un.org/sdg/2",
        display_name: "Zero hunger",
        count: 11346798
    },
    {
        id: "https://metadata.un.org/sdg/15",
        display_name: "Life in Land",
        count: 10643894
    },
    {
        id: "https://metadata.un.org/sdg/5",
        display_name: "Gender equality",
        count: 10576385
    },
    {
        id: "https://metadata.un.org/sdg/7",
        display_name: "Affordable and clean energy",
        count: 10508209
    },
    {
        id: "https://metadata.un.org/sdg/6",
        display_name: "Clean water and sanitation",
        count: 9384598
    },
    {
        id: "https://metadata.un.org/sdg/11",
        display_name: "Sustainable cities and communities",
        count: 8161877
    },
    {
        id: "https://metadata.un.org/sdg/14",
        display_name: "Life below water",
        count: 6560450
    },
    {
        id: "https://metadata.un.org/sdg/13",
        display_name: "Climate action",
        count: 6138479
    },
    {
        id: "https://metadata.un.org/sdg/1",
        display_name: "No poverty",
        count: 2298235
    },
    {
        id: "http://metadata.un.org/sdg/3",
        display_name: "Good health and well-being",
        count: 49
    },
    {
        id: "http://metadata.un.org/sdg/9",
        display_name: "Industry, innovation and infrastructure",
        count: 41
    },
    {
        id: "http://metadata.un.org/sdg/4",
        display_name: "Quality Education",
        count: 33
    },
    {
        id: "http://metadata.un.org/sdg/10",
        display_name: "Reduced inequalities",
        count: 29
    },
    {
        id: "http://metadata.un.org/sdg/16",
        display_name: "Peace, Justice and strong institutions",
        count: 26
    },
    {
        id: "http://metadata.un.org/sdg/12",
        display_name: "Responsible consumption and production",
        count: 20
    },
    {
        id: "http://metadata.un.org/sdg/7",
        display_name: "Affordable and clean energy",
        count: 20
    },
    {
        id: "http://metadata.un.org/sdg/5",
        display_name: "Gender equality",
        count: 14
    },
    {
        id: "http://metadata.un.org/sdg/11",
        display_name: "Sustainable cities and communities",
        count: 13
    },
    {
        id: "http://metadata.un.org/sdg/13",
        display_name: "Climate action",
        count: 12
    },
    {
        id: "http://metadata.un.org/sdg/14",
        display_name: "Life below water",
        count: 11
    },
    {
        id: "http://metadata.un.org/sdg/2",
        display_name: "Zero hunger",
        count: 11
    },
    {
        id: "http://metadata.un.org/sdg/6",
        display_name: "Clean water and sanitation",
        count: 10
    },
    {
        id: "http://metadata.un.org/sdg/8",
        display_name: "Decent work and economic growth",
        count: 9
    },
    {
        id: "http://metadata.un.org/sdg/15",
        display_name: "Life in Land",
        count: 4
    },
    {
        id: "http://metadata.un.org/sdg/1",
        display_name: "No poverty",
        count: 3
    }
]

export {
    openAlexSdgs
}